// src/layouts/HomeLayout/index.tsx
import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import Navbar from "src/components/home/Navbar";
import Footer from "src/components/home/Footer";
import { Container, Box, useMediaQuery, useTheme } from "@mui/material";
import { usePullToRefresh } from "src/hooks/usePullToRefresh/usePullToRefresh";
import { PullToRefreshIndicator } from "src/components/common/PullToRefreshIndicator/PullToRefreshIndicator";

interface HomeLayoutProps {
  children?: ReactNode;
}

const HomeLayout: FC<HomeLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const mediaDownLG = useMediaQuery(theme.breakpoints.down("lg"));
  const mediaDownMD = useMediaQuery(theme.breakpoints.down("md"));
  const mediaDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const mediaDownXS = useMediaQuery(theme.breakpoints.down("xs"));
  const isMobile = localStorage.getItem("isMobile");

  // Pull to refresh logic
  const handleRefresh = async () => {
    window.location.reload();
  };

  const { containerRef, isRefreshing, pullDistance, threshold } = 
    usePullToRefresh({ 
      onRefresh: handleRefresh,
      disabled: (isMobile == "false" || isMobile == null) // Disabled kalau bukan mobile
    });

  const shouldEnablePTR = !(isMobile == "false" || isMobile == null);

  return (
    <Box 
      ref={shouldEnablePTR ? containerRef : null}
      sx={{ 
        backgroundColor: "white",
        ...(shouldEnablePTR && {
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden"
        })
      }}
    >
      {/* Refresh Indicator - Hanya muncul di mobile */}
      {shouldEnablePTR && (
        <PullToRefreshIndicator
          isRefreshing={isRefreshing}
          pullDistance={pullDistance}
          threshold={threshold}
        />
      )}

      <Navbar />
      <Container 
        maxWidth="lg" 
        sx={{ 
          position: "relative", 
          mt: (isMobile === "false" || isMobile === null) || (!mediaDownSM && !mediaDownXS && !mediaDownMD && !mediaDownLG) ? 12 : 2, 
          minHeight: "100vh" 
        }}
      >
        {children || <Outlet />}
      </Container>
      <Footer />
    </Box>
  );
};

HomeLayout.propTypes = {
  children: PropTypes.node,
};

export default HomeLayout;